import { render, staticRenderFns } from "./GoldSchemePayment.vue?vue&type=template&id=5631c8c4&scoped=true&"
import script from "./GoldSchemePayment.vue?vue&type=script&lang=js&"
export * from "./GoldSchemePayment.vue?vue&type=script&lang=js&"
import style0 from "./GoldSchemePayment.vue?vue&type=style&index=0&id=5631c8c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631c8c4",
  null
  
)

export default component.exports